import { ButtonProps } from 'Components/Button/Button';
import styles from './Button.module.scss';
import classNames from 'classnames';
import { Button as BaseButton } from 'Components';

interface BtnProps extends ButtonProps {
	variant?: 'border' | 'borderless';
}

const Button: React.FC<BtnProps> = ({
	size,
	children,
	onClick,
	variant,
	className,
	...rest
}) => {
	return (
		<BaseButton
			size={size}
			onClick={onClick}
			className={classNames(
				styles.btns,
				variant && styles[`btns--${variant}`],
				className
			)}
			{...rest}
		>
			{children}
		</BaseButton>
	);
};

export default Button;
